import React from 'react';
import { useGate } from './useGate';
import { STATSIG_GATES } from './gates';
import { shouldAllowPilotAccess } from './pilotAccess';
import { PilotUnavailable } from './PilotUnavailable';

/**
 * Gates the whole registration flow on the `access_registration_pilot` Statsig
 * gate (RND-36404). Renders children when access is allowed, otherwise the
 * "not available yet" screen. Must be rendered inside a StatsigProvider.
 */
export const PilotGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const gate = useGate(STATSIG_GATES.ACCESS_REGISTRATION_PILOT);

  if (!shouldAllowPilotAccess(gate)) {
    return <PilotUnavailable />;
  }

  return <>{children}</>;
};
